// @flow
import { INCREMENT_PAGINATION_INDEX } from './types';
import type { IncrementPaginationIndexActionType } from '../types';

export function incrementPaginationIndex(): IncrementPaginationIndexActionType {
  return {
    type: INCREMENT_PAGINATION_INDEX
  };
}
